<template>
    <div class="SX">
       <div class="container">
      <div class="title-tab">
        <span>当前位置：</span>
        <span @click="GoRisk">首页></span>
        <span @click="GoSiXiang">巡视巡察></span>
          <span @click="GoJT">集团动态></span>
        <span class="red">正文</span>
      </div>
      <!-- 正文 -->
    <div class="zhengwen">
      <h1>“三个全面”着力营造巡察工作舆论氛围</h1>
      <div class="first">
        <span class="third">来源：新华社</span>
         <span class="si">|</span>
        <span>发布时间：2020-5-20 13:30</span>
      </div>
       <div class="xh"></div>
      <div class="second">
        <p>今年以来，崇信县牢牢把握政治巡察的定位和要求，坚持以习近平新时代中国特色社会主义思想为指导，严格贯彻落实习近平总书记关于巡视巡察工作重要论述精神，扎实推进巡察全覆盖，以“三个全面”为切入点，不断加大巡察工作宣传力度，着力提升广大党员干部和群众对巡察工作的知晓率和支持率，营造良好的巡察工作氛围。</p>

        <strong><p>　　一是宣传告知全面覆盖。</p></strong>

        <p>充分运用新媒体网络平台，在电视台、门户网、崇信发布、“清风崇信”公众号等平台发布县委第五轮巡察公告5次，并动员干部群众积极转发，扩大宣传面；巡察进驻后，在被巡察单位门口，人口密集、位置显眼的地方张贴巡察公告26张，同时督促被巡察单位以内部文件或发布信息的方式公开巡察部分内容9次；通过广泛宣传发动，将巡察工作相关信息和政策及时传播，使广大干群全面了解巡察工作的目的、意义、开展方式等，打消干部群众心中的顾虑，引导干部群众积极参与、配合巡察工作。</p>

        <p> </p>
          <strong><p>二是信访通道全面畅通。　 </p></strong>

        <p>县委第五轮巡察共设立举报信箱3个、举报电话2个、电子邮箱2个，公开信访接待地点2个。巡察进驻后，及时召开动员会、发放信访举报明白卡、张贴信访举报投诉宣传画、悬挂横幅，在电视、报刊、电子网站、微信公众号等媒介公布公开举报渠道和方式方法，扩大群众知晓率，为群众反映问题开辟“绿色通道”，进一步拓展了问题线索来源，促进了社会监督作用的发挥。巡察期间巡察组深入群众家中、田间地头，在巡察一线听取群众知心话，打通联系群众的“最后一公里”。</p>
 <strong><p>三是整改成效全面公开。　 </p></strong>
        <p>巡察结束后，及时召开反馈会，向被巡察单位反馈巡察情况，指出存在问题，提出整改意见建议。同时，将巡察反馈情况和整改情况通过电视、报刊等网络媒体进行全面公开，体现巡察工作的公开透明和公正严谨，提升广大干部群众对巡察工作的满意度。督促县委第四轮被巡察单位，即3个县直单位和57个行政村及时报送整改进展情况的社会公开稿、党内公开稿，发出督办函60份。截止目前，各单位报送的公开稿已经3次审核，即将全面公开公示。</p>
      </div>
    </div>
      
    
    </div>


    </div>
</template>
<script>
export default {
    methods: {
         GoRisk() {
      this.$router.push("/HOME");
    },
   GoSiXiang() {
      this.$router.push("/MakeInspectionTour");
    },
   GoJT() {
      this.$router.push("/MakeInspectionTour/JiTuan");
    },
    },
    
}
</script>
<style lang="less" scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}
.title-tab {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 54px;
  cursor: pointer;
}
.red {
  color: red;
}
.zhengwen {
  width: 1200px;
  background-color: white;
  padding: 60px;
  box-sizing: border-box;
}
p {
  text-indent: 2em;
  font-size: 16px;
  color: #333333;
  margin-top: 20px;
}
p:nth-child(1) {
  text-indent: 0;
}
h1 {
  text-align: center;
  font-size: 28px;
  color: #333333;
}
.first {
  text-align: center;
  font-size: 16px;
  color: #999999;
  margin-top: 28px;
  margin-bottom: 30px;
}
.daohang {
  margin: 20px 0;
}
.si{
   margin: 0 16px;
 }
</style>